// import cx from 'classnames';
import Pattern from './Pattern';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Path(_ref) {
  let {
    id,
    width,
    height,
    path,
    fill = 'transparent',
    stroke,
    strokeWidth,
    strokeDasharray,
    strokeLinecap = 'square',
    shapeRendering = 'auto',
    background,
    className
  } = _ref;
  return /*#__PURE__*/_jsxs(Pattern, {
    id: id,
    width: width,
    height: height,
    children: [!!background && /*#__PURE__*/_jsx("rect", {
      width: width,
      height: height,
      fill: background
    }), /*#__PURE__*/_jsx("path", {
      // className={cx('visx-pattern-path', className)}
      d: path,
      fill: fill,
      stroke: stroke,
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      strokeLinecap: strokeLinecap,
      shapeRendering: shapeRendering
    })]
  });
}